import React from 'react';
import {
  Stack,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { bold } from '@styles/fontWeights';
import { OnboardingPackage } from '@features/digitalOnboarding';
import { Delete, Edit } from '@mui/icons-material';

function EnterpriseOnboardingPackages({
  templates,
  setOnboardingPackageData,
  setIsOnboardingPackageModalOpen,
  setIsDeletingModalOpen,
}: {
  templates: OnboardingPackage[];
  setOnboardingPackageData: (data: OnboardingPackage) => void;
  setIsOnboardingPackageModalOpen: (value: boolean) => void;
  setIsDeletingModalOpen: (value: boolean) => void;
}) {
  return (
    <Stack width="100%">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Package Name</strong>
              </TableCell>
              <TableCell>
                <strong>Positions</strong>
              </TableCell>
              <TableCell align="right">
                <strong>Actions</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templates.map((item: OnboardingPackage) => (
              <TableRow key={item.package_name}>
                <TableCell>
                  <Typography variant="h6" sx={{ maxWidth: '400px', wordBreak: 'break-word', fontWeight: bold }}>
                    {item.package_name}
                  </Typography>
                </TableCell>
                <TableCell sx={{ maxWidth: '400px', wordBreak: 'break-word' }}>
                  {item.positions
                    .map((pos: { s_title: string }) => pos.s_title)
                    .join(' - ')}
                </TableCell>
                <TableCell align="right">
                  <Stack direction="row" spacing={2} justifyContent="end">
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      startIcon={<Edit />}
                      onClick={() => {
                        setOnboardingPackageData(item);
                        setIsOnboardingPackageModalOpen(true);
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      startIcon={<Delete />}
                      onClick={() => {
                        setOnboardingPackageData(item);
                        setIsDeletingModalOpen(true);
                      }}
                    >
                      Delete
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}

export default EnterpriseOnboardingPackages;
